/**
 * Standardized popup/modal color scheme and styles
 */
export const POPUP_COLORS = {
  background: '#B4D9D4',      // Main popup background
  fieldBackground: '#EBF5F5', // Input field background
  buttonBackground: '#EBF5F5', // Button background
  buttonText: '#3A7380',       // Button text color
  titleText: '#366A75',        // Title text color
  buttonHover: '#D0E7E5',      // Button hover color
  closeBtnHover: '#2D5A60',    // Close button hover color
};

export const POPUP_STYLES = {
  container: 'fixed inset-0 bg-black/50 flex items-center justify-center z-[1000] p-4',
  modal: 'bg-[#B4D9D4] rounded-3xl px-8 pb-8 w-full shadow-2xl relative max-w-md',
  headerContainer: 'relative pt-1 pb-5',
  headerInner: 'flex items-center justify-center',
  title: 'text-2xl font-bold text-[#366A75]',
  closeButton: 'absolute right-0 text-[#366A75] hover:text-[#2D5A60] transition-colors disabled:opacity-50',
  input: 'w-full px-4 py-2 rounded-lg bg-[#EBF5F5] border border-[#B4D9D4] focus:outline-none focus:ring-2 focus:ring-[#366A75] focus:border-transparent',
  // `input`, with the bare `border` class swapped for `border-[1px]`. Identical to look at
  // in isolation, but the border actually takes the colour beside it: bootstrap.min.css is
  // imported globally in index.tsx and defines `.border` as
  // `border: 1px solid #dee2e6 !important`, which silently wins over Tailwind's colour
  // wherever the two class names meet. Currently used by the medical opinion modals only -
  // the rest of the app still renders Bootstrap's grey. When that is fixed app-wide, fold
  // this back into `input` and delete it.
  inputBordered: 'w-full px-4 py-2 rounded-lg bg-[#EBF5F5] border-[1px] border-[#B4D9D4] focus:outline-none focus:ring-2 focus:ring-[#366A75] focus:border-transparent',
  button: 'px-8 py-2 bg-[#EBF5F5] text-[#3A7380] rounded-xl shadow-sm hover:bg-[#D0E7E5] transition-all disabled:opacity-50 disabled:cursor-not-allowed font-medium border-0 outline-none',
  // Instructional and confirmation copy - never a field. Square corners and the modal's own
  // background, delimited by a border alone, so it cannot be mistaken for something the user
  // is meant to type into or click. The border is the text colour: the box reads as one mark
  // rather than as a frame around something.
  //
  // `border-[1px]`, not `border`: bootstrap.min.css is imported globally in index.tsx and its
  // own `.border` utility is `border: 1px solid #dee2e6 !important`, which overrides both
  // Tailwind's width class and whatever border colour follows it. The arbitrary-width class
  // has a name Bootstrap does not define, so the colour survives.
  note: 'p-3 bg-[#B4D9D4] border-[1px] border-current text-[#2D5A60] text-sm',
};

// Modal width constants (Tailwind max-width classes)
export const MODAL_WIDTHS = {
  default: 'max-w-md',        // 28rem (448px)
  wide: 'max-w-lg',            // 32rem (512px) - ~20% wider than default
  extra_wide: 'max-w-xl',      // 36rem (576px)
  xxl: 'max-w-2xl',            // 42rem (672px)
  xxxl: 'max-w-3xl',           // 48rem (768px)
  xxxxl: 'max-w-4xl',          // 56rem (896px)
  full: 'max-w-5xl',           // 64rem (1024px)
  pdfViewer: 'w-[80vw]',       // 80% of viewport width
};
